{
  "de": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Logo ändern (png erforderlich)",
        "changeThemeColor": "Neue Themenfarbe auswählen"
      },
      "errors": {
        "themeColorInvalid": "Geben Sie sechs Zeichen ein, 0-9 oder A-F. Zum Beispiel 096553."
      },
      "labels": {
        "customerThemeColor": "Themenfarbe für Kunden",
        "customerThemeColorExlainer": "Diese Farbe wird für das Kundenportal verwendet. Übernehmen Sie die Identität eines Kunden, um dies in Aktion zu sehen.",
        "logo": "Logo"
      },
      "picture_logo_format": {
        "round": "Rundes Logo",
        "square": "Quadratisches Logo"
      }
    }
  }
}
